import axios from "axios";
import { COOKIE_NAME } from "data/constants";
import { AUTH_STORAGE_KEY } from "domain/authentication";

const apiUrl = process.env.REACT_APP_API_URL;

const baseURL = apiUrl?.startsWith("http") ? apiUrl : `https://${apiUrl}`;

export const api = axios.create({
  baseURL,
  headers: {
    Authorization: "Bearer ",
  },
});

export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

export const deleteCookie = (name: string, path = '/') => {
  document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}


api.interceptors.request.use(async (request) => {
  const token = getCookie(COOKIE_NAME);
  if (!token) return request;

  if (request.headers) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { status } = error.response;
    if (status === 401) {
      localStorage.removeItem(AUTH_STORAGE_KEY);
      deleteCookie(COOKIE_NAME);
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export const unauthorizedApi = axios.create({
  baseURL,
});
